const CONFIGURACION_DESPACHOS_HARDCODED_YPF = {
  despachos_TiempoAMostrar: 0,
  despachos_TiempoDeRefresco: 15,
  despachos_CantidadAMostrar: 50,
  remitosFiscalesValorizado: false,
  imprimirPrecioSinImpuestosYTributosEnTIKFAB: true,
};

const getConfiguracionDespachos = async () => {
  return CONFIGURACION_DESPACHOS_HARDCODED_YPF;
};

const configuracionDespachos = {
  getConfiguracionDespachos,
};

export default configuracionDespachos;
